import { render, staticRenderFns } from "./updateDataDialog.vue?vue&type=template&id=65e617c4&scoped=true&"
import script from "./updateDataDialog.vue?vue&type=script&lang=js&"
export * from "./updateDataDialog.vue?vue&type=script&lang=js&"
import style0 from "./updateDataDialog.vue?vue&type=style&index=0&id=65e617c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e617c4",
  null
  
)

export default component.exports